// App.js
import React, { useState, lazy } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Outlet,
	Link,
	useNavigate,
	Navigate,
} from "react-router-dom";
// import BottomTab from "./pages/BottomTab";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
// import ShowGraph from "./pages/ShowGraph";
// import Tab1 from "./pages/Tab1";
//import ComplaintsList from './pages/ComplaintsList';
// import Logout from "./pages/LogOut";
import "./styles/bottomtab.css";
// import Medicine from "./pages/Medicine";
// import RecordAudio from "./components/RecordAudio";
//import { lazyLoad } from './lazyLoad';
import RegistrationPage from "./pages/RegistrationPage";
// import Dashboard from "./pages/Dashboard";
// import PaymentSettings from "./pages/PaymentSettings";
// import SubscriptionPlan from "./pages/SubscriptionPlan";
// import FrontPage from "./pages/FrontPage";
// import CreatedVideoList from "./pages/CreatedVideoList";
import Support from "./pages/SupportBox";
// import SentenceExam from "./pages/SentenceExam";
// import SentenceLearn from "./pages/SentenceLearn";
// import VocabExam from "./pages/VocabExam";
// import VocabLearn from "./pages/VocabLearn";
import { Toolbar } from "@mui/material";
import NavBar from "./components/Navbar/Navbar";
import Record from "./pages/Record";
import { useAuth } from "react-oidc-context";
import Profile from "./pages/Profile";
import AppointmentRequests from "./pages/AppointmentRequests";
import UploadPrescription from "./pages/UploadPrescription";
import UploadedRecord from "./pages/UploadedRecord";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailure from "./pages/PaymentFailure";

//https://www.youtube.com/watch?v=JU6sl_yyZqs
//const LoginPage=lazyLoad('./pages/LoginPage.jsx','Login')
//const LandingPage=lazy(()=>import('./pages/LandingPage.jsx'))

const Private = () => {
	const auth = useAuth();
	return auth.isAuthenticated || auth.isLoading ? (
		<Outlet />
	) : (
		<Navigate to="/" />
	);
};

var setLoading;

const App = () => {
	const [loading, setL] = useState(true);
	setLoading = setL;
	return (
		<div>
			{loading ? (
				<div className="bu-bg-color fixed z-40 top-0 left-0 w-full h-full flex justify-center items-center">
					<div className="border-[6px] border-solid border-zinc-200 dark:border-gray-800 rounded-full border-t-[8px] border-t-black w-14 h-14 animate-spin"></div>
				</div>
			) : (
				<></>
			)}
			<Router>
				<Toolbar />
				<NavBar />
				<Routes>
					<Route element={<Private />}>
						<Route exact path="/records" element={<Record />} />
						<Route exact path="/support" element={<Support />} />
						<Route exact path="/profile" element={<Profile />} />
						<Route
							exact
							path="/uploaded_records"
							element={<UploadedRecord />}
						/>
						<Route
							exact
							path="/upload"
							element={<UploadPrescription />}
						/>
					</Route>
					<Route
						exact
						path="/appt_requests"
						element={<AppointmentRequests />}
					/>

					<Route exact path="/payment" element={<Payment />} />
					<Route exact path="/payment-success" element={<PaymentSuccess />} />
					<Route exact path="/payment-failure" element={<PaymentFailure />} />

					<Route exact path="/" element={<LandingPage />} />

					{/* <Route exact path="/login" element={<LoginPage />} /> */}

					{/* <Route
					exact
					path="/registration"
					element={<RegistrationPage />}
				/>
				<Route path="/landing/*" element={<LandingPage />} />
				<Route path="/landing/advices" element={<VocabExam />} />
				<Route
					path="/landing/health-advice"
					element={<LandingPage />}
				/> */}
					{/*<Route path="/landing/tab2/*" element={<PrescriptionList />} />*/}
					{/* <Route
					path="/landing/subscription"
					element={<SubscriptionPlan />}
				/>
				<Route
					path="/landing/VideoList"
					element={<CreatedVideoList />}
				/>
				<Route path="/landing/support" element={<Support />} />
				<Route path="/landing/tab3/*" element={<PaymentSettings />} />
				<Route path="/landing/tab4" element={<Logout />} />
				<Route path="/landing/tab5" element={<RecordAudio />} /> */}

					{/*<Route path={`/tab3/Sleep`} element={<Sleep />} />*/}
				</Routes>
			</Router>
		</div>
	);
};

export default App;
export { setLoading };
